import { readCheckedValue } from '../../field-viewer/prehydration-readers';
import { acceptOnlyValidOptionByLabel } from '../../field-viewer/shared-normalizers';
export const radioGroupViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByLabel,
    readPrehydrationValue: readCheckedValue
};

//# sourceMappingURL=definition-viewer.js.map